import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyD_CfDnJndX0hNOUaGHS5SGrXDp3Eiorjk",
  authDomain: "hands-simulador.firebaseapp.com",
  projectId: "hands-simulador",
  storageBucket: "hands-simulador.appspot.com",
  messagingSenderId: "759561920995",
  appId: "1:759561920995:web:a66686c0e48438c49f00d6",
  measurementId: "G-V80HQ8NZEP"
};

firebase.initializeApp(firebaseConfig);